import { Link } from "react-router-dom";
import Vector from "../../images/products/vector.png";
import Dashboard from "../../images/products/dashboard.png";
import Grid from "../../images/products/grid.png";

function ProductsHero() {
  return (
    <div className="products-hero">
      <img src={Vector} alt="vector" className="vector" />
      <img src={Grid} alt="grid" className="grid" />
      <img src={Dashboard} alt="dashboard" className="dashboard" />
      <div className="heading">
        <h1>Engineering solutions for smarter work</h1>
        <h2>
          We build platforms that make work simpler, faster, and easier to
          manage. Everything we create is shaped by the real problems teams face
          every day — and the need to fix them properly. No fluff, just
          thoughtful tools that work.
        </h2>
        <Link to="/services">
          <button>
            <p className="text">Get started</p>
            <div />
          </button>
        </Link>
        <div className="stats">
          <div>
            <h2 className="number">30+</h2>
            <p>Projects</p>
          </div>
          <div>
            <h2 className="number">20+</h2>
            <p>Teams</p>
          </div>
          <div>
            <h2 className="number">100k+</h2>
            <p>Users</p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProductsHero;
